/* eslint-disable max-lines */
import styled from 'styled-components'
import { theme } from '../../styles'

export const Root = styled.section`
  position: relative;
  overflow: hidden;
  background: linear-gradient(155deg, ${theme.cores.navy700} 0%, ${theme.cores.navy} 46%, ${theme.cores.navyDeep} 100%);
  color: ${theme.cores.white};
  border-radius: ${theme.raio.lg};
  padding: 26px 28px 24px;
  box-shadow: ${theme.sombras.passport};
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    right: -70px;
    top: -70px;
    width: 230px;
    height: 230px;
    border-radius: 50%;
    background: repeating-radial-gradient(circle, rgba(255, 255, 255, 0.06) 0 1px, transparent 1px 9px);
    opacity: 0.7;
    pointer-events: none;
  }

  ${theme.mobile} {
    padding: 22px 20px 20px;
    border-radius: 24px;
  }
`

export const Head = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;

  ${theme.mobile} {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
`

export const HeadBrand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`

export const Title = styled.h1`
  font-size: 25px;
  line-height: 1.05;
  margin: 0;
  color: ${theme.cores.white};

  em {
    color: ${theme.cores.accentSoft};
    font-style: italic;
    font-family: ${theme.fontes.serif};
  }

  ${theme.mobile} {
    font-size: 23px;
  }
`

export const RenewLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 9px;
  padding: 8px 12px;
  font-size: 12.5px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.78);
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 9px;

  b {
    color: ${theme.cores.white};
    font-weight: 700;
  }

  svg {
    flex: none;
    color: ${theme.cores.accentSoft};
  }

  ${theme.mobile} {
    font-size: 12px;
  }
`

const statusDotColors = {
  'ativa': '#7CD49A',
  'solicitouCancelamento': '#F09089',
  'cancelada': '#F09089'
}

export const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 13px 7px 11px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: ${theme.cores.white};
  white-space: nowrap;

  ${theme.mobile} {
    align-self: flex-start;
    order: -1;
  }
`

export const StatusDot = styled.span`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: none;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.08);
  background: ${( { $status } ) => statusDotColors[ $status ]};
`

export const StatusPillCal = styled.button`
  display: inline-grid;
  place-items: center;
  margin-left: 2px;
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: 7px;
  cursor: pointer;
  border: 1px solid rgba(240, 144, 137, 0.5);
  background: rgba(240, 144, 137, 0.14);
  color: #F09089;
  font-family: inherit;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(240, 144, 137, 0.28);
  }
`

export const AlertaFalha = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  gap: 13px;
  align-items: flex-start;
  padding: 14px 16px;
  margin-top: 16px;
  border-radius: 12px;
  border: 1px solid rgba(240, 144, 137, 0.4);
  background: rgba(240, 144, 137, 0.12);
`

export const AlertaFalhaIcon = styled.span`
  flex: none;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(240, 144, 137, 0.2);
  color: #F5B3AD;
`

export const AlertaFalhaBody = styled.div`
  min-width: 0;

  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.55;
    color: rgba(255, 255, 255, 0.86);
  }

  b {
    color: #F5B3AD;
    font-weight: 700;
  }
`

export const AlertaFalhaBtn = styled.button`
  margin-top: 12px;
  padding: 10px 18px;
  border: none;
  border-radius: 999px;
  font-size: 13.5px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  background: #E2635C;
  color: ${theme.cores.white};
  transition: background 0.2s ease;

  &:hover {
    background: #CF524B;
  }
`

export const HeroStats = styled.div`
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 0.8fr 2fr;
  gap: 26px;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.14);

  ${theme.mobile} {
    grid-template-columns: 1fr;
    gap: 0;
    margin-top: 18px;
    padding-top: 16px;
  }
`

export const HeroPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-right: 26px;
  border-right: 1px solid rgba(255, 255, 255, 0.14);

  ${theme.mobile} {
    padding: 0 0 16px;
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.14);
  }
`

export const StatKey = styled.div`
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 4px;

  ${theme.mobile} {
    font-size: 9.5px;
    letter-spacing: 0.08em;
  }
`

export const PriceValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-family: ${theme.fontes.serif};
  font-weight: 600;
  line-height: 1.05;
  color: ${theme.cores.white};

  ${theme.mobile} {
    flex-direction: row;
    align-items: baseline;
    justify-content: center;
    gap: 8px;
  }
`

export const PriceOld = styled.span`
  font-family: ${theme.fontes.serif};
  font-size: 20px;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: line-through;

  ${theme.mobile} {
    font-size: 18px;
  }
`

export const PriceBig = styled.span`
  font-size: 40px;
  color: ${theme.cores.accentSoft};

  ${theme.mobile} {
    font-size: 31px;
    white-space: nowrap;
  }
`

export const PriceSmall = styled.small`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);

  ${theme.mobile} {
    margin-top: 6px;
  }
`

export const PriceNotes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-top: 8px;

  ${theme.mobile} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
`

export const PriceNote = styled.span`
  display: inline-block;
  padding: 3px 9px;
  border-radius: 999px;
  border: 1px solid ${theme.cores.whiteAlpha20};
  background: ${theme.cores.whiteAlpha10};
  font-size: 10.5px;
  letter-spacing: 0.04em;
  color: ${theme.cores.accentSoft};
`

export const HeroBrindes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${theme.mobile} {
    margin-top: 16px;
  }
`

export const BrindesGrid = styled.div`
  --gap-brindes: 14px;
  display: grid;
  justify-content: center;
  gap: var(--gap-brindes);
  grid-template-columns: ${( { $unico } ) => ( $unico
    ? 'minmax(0, calc(50% - var(--gap-brindes) / 2))'
    : 'repeat(2, minmax(0, 1fr))' )};

  ${theme.mobile} {
    --gap-brindes: 10px;
  }
`

export const BrindeCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 10px;
  border-radius: ${theme.raio.md};
  background: ${theme.cores.whiteAlpha10};
  border: 1px solid ${theme.cores.whiteAlpha20};
`

export const BrindeFoto = styled.div`
  aspect-ratio: 1 / 1;
  border-radius: ${theme.raio.sm};
  overflow: hidden;
  background: #ECE8E5;
  display: grid;
  place-items: center;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const BrindeVazio = styled.span`
  padding: 0 12px;
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  text-align: center;
  color: ${theme.cores.inkFaint};
`

export const BrindeLegenda = styled.div`
  font-size: 12.5px;
  font-weight: 700;
  line-height: 1.35;
  color: ${theme.cores.white};
`

export const Actions = styled.div`
  position: relative;
  z-index: 2;
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.16);

  ${theme.mobile} {
    margin-top: 20px;
    padding-top: 18px;
  }
`

export const ActionsEyebrow = styled.div`
  display: block;
  font-size: 11px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 5px;
`

export const ActionsNota = styled.p`
  margin: 0 0 16px;
  font-size: 12px;
  line-height: 1.45;
  color: ${theme.cores.whiteAlpha60};
`

export const ActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;

  ${theme.mobile} {
    grid-template-columns: 1fr;
    gap: 9px;
  }
`
